import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorIntegrationId extends IdValueObject {
  static create(value: string): SharingVendorIntegrationId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorIntegrationId(value);
  }
}
